export default __webpack_public_path__ + "static/media/buen_fin.176f077b.svg";